module.exports = __webpack_public_path__ + "img/tu-1_18.1b48a853.jpg";